import {Component} from '@angular/core';
import {DateTime} from 'luxon';
import {AssertionUtils} from '../../../common/utils/assertion-utils';
import {ScheduleItem} from '../schedule-item.interface';
import {ScheduleItemWithWidth} from './schedule-item-with-width.interface';
import {TimelineRowCellRendererParams} from './timeline-row.interface';
import {TimelineRowService} from './timeline-row.service';

@Component({
  selector: 'vdw-timeline-row',
  templateUrl: './timeline-row.component.html',
  styleUrls: ['./timeline-row.component.scss']
})
export class TimelineRowComponent {
  public scheduleItems: ScheduleItemWithWidth[] = [];
  public isPastDay = false;
  public isCurrentDay = false;
  public isWorkingDay = false;
  public isSelected = false;
  public date: DateTime;
  public paddingLeft: number;
  public onRowButtonClicked: (index: number) => void;
  public onScheduleItemDeleted: (scheduleItem: ScheduleItem) => void;
  public onScheduleItemCheckboxClicked: () => void;

  public constructor(private readonly timelineRowService: TimelineRowService) {}

  public agInit(params: TimelineRowCellRendererParams): void {
    this.isWorkingDay = params.data.isWorkingDay ?? true;
    this.date = params.data.date;
    this.isCurrentDay = !AssertionUtils.isNullOrUndefined(params.data.date) && params.data.date?.hasSame(DateTime.now(), 'day');
    this.isPastDay = !AssertionUtils.isNullOrUndefined(params.data.date) && params.data.date < DateTime.now().startOf('day');
    this.isSelected = params.node.isSelected();

    const previousDayEndTime = params.api
      ?.getDisplayedRowAtIndex(params.node.rowIndex - 1)
      ?.data?.scheduleItems?.at(-1)
      ?.endTime?.minus({days: 1});

    if (previousDayEndTime > params.startTime) {
      this.paddingLeft = this.timelineRowService.calculateWidth(params.startTime, previousDayEndTime, false);
    }
    if (!AssertionUtils.isNullOrUndefined(params.value)) {
      this.scheduleItems = this.timelineRowService.getScheduleItems(params.value, previousDayEndTime > params.startTime ? previousDayEndTime : params.startTime, params.startTime.plus({days: 1}));
    }

    this.onRowButtonClicked = (index: number): void => {
      params.onRowButtonClicked(params.node, this.scheduleItems[index - 1]?.scheduleItem?.endTime, this.scheduleItems[index + 1]?.scheduleItem?.startTime);
    };
    this.onScheduleItemDeleted = (scheduleItem: ScheduleItem): void => {
      params.node.setDataValue(
        params.colDef.field,
        params.data.scheduleItems.filter((item: ScheduleItem) => item.id !== scheduleItem.id)
      );
      params.onScheduleItemDeleted(scheduleItem, params.data.date);
    };
    this.onScheduleItemCheckboxClicked = (): void => {
      params.api.refreshCells({rowNodes: [params.node], force: true});
      params.api.refreshHeader();
    };
  }
}
